import { AxiosRequestConfig } from 'axios';

import { appendQueryStringToUrl } from 'shared/helpers/utils/url';


export const catalogTagFilter = (requestConfig: AxiosRequestConfig) => {
  const { headers, url } = requestConfig;

  if (headers.CATALOG_TAG_FILTER && url) {
    const modifiedUrl = appendQueryStringToUrl(url, `catalog_tag_filter=${__PLATFORM__}`);
    requestConfig.url = modifiedUrl;
  }
  delete headers.CATALOG_TAG_FILTER;
  return requestConfig;
};
